<div fxLayout="column" fxLayoutGap="16px">

  <ng-container *ngIf="jobStatus.status === JobStatus.IN_PROGRESS || jobStatus.status === JobStatus.WAITING">
    <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <mat-spinner mode="indeterminate" color="accent" diameter="64" strokeWidth="5"></mat-spinner>
      <span>{{ 'MASSIVE_COMPANY_DIALOG.WAITING_IMPORT' | translate }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.ERROR">
    <h2>{{ 'MASSIVE_COMPANY_DIALOG.ERROR.ERROR' | translate }}</h2>

    <ul fxFlex>
      <li *ngFor="let error of jobStatus.errors">
        <span>{{ error }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.COMPLETED">
    <h3>{{ 'MASSIVE_COMPANY_DIALOG.IMPORT_COMPLETE' | translate }}</h3>
  </ng-container>
</div>
